import { ReactNode } from 'react';
import { ListSubheader } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Tooltip } from '@efexteam/components';
import GroupHeaderStyles from './GroupHeader.styles';

interface GroupHeaderProps {
  title: ReactNode;
  tooltipTitle?: string;
}

export const GroupHeader = ({
  title = '',
  tooltipTitle = '',
}: GroupHeaderProps) => (
  <ListSubheader className={GroupHeaderStyles.container} component="div">
    {title}
    <Tooltip title={tooltipTitle}>
      <InfoIcon className={GroupHeaderStyles.infoIcon} fontSize="small" />
    </Tooltip>
  </ListSubheader>
);

export default GroupHeader;
